import { CSmartPagination } from "@coreui/react-pro";
import React from "react";

/**
 * @function CustomPagination
 * @description for CustomPagination
 * @returns JSX for CustomPagination
 */
const CustomPagination = ({
  pageNo,
  totalPage,
  pageChangeHanlder,
  limit,
  limitHanlder,
}) => {
  return (
    <div className="pagination-container">
      <CSmartPagination
        align="start"
        activePage={pageNo}
        className="cursor-pointer"
        doubleArrows={false}
        onActivePageChange={pageChangeHanlder}
        pages={totalPage}
      />

      <div className="limit-container">
        <label htmlFor="pagination" className="pagination-label">
          {"Items Per Page "}
        </label>
        <select
          defaultValue={limit}
          name="pagination"
          onChange={limitHanlder}
          className="select-container"
        >
          <option className="otption" value={5}>
            {5}
          </option>
          <option className="otption" value={10}>
            {10}
          </option>
          <option className="otption" value={20}>
            {20}
          </option>
          <option className="otption" value={50}>
            {50}
          </option>
        </select>
      </div>
    </div>
  );
};

export default CustomPagination;
